//
//
//
//
//
//
//
//
//
//
//

import {base} from '../../common/mixins'

export default {
  name: 'Cell',
  mixins: [base],
  props: {
    icon: {
      // 左侧icon，需使用 require() 引入
      type: String,
      default: null,
    },
    title: {
      // 左侧标题
      type: String,
      default: null,
    },
    value: {
      // 右侧文字
      type: String,
      default: null,
    },
    showArrow: {
      // 显示右侧箭头
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {}
  },
  mounted () {},
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Group/Cell.vue